export default __webpack_public_path__ + "static/media/share-01.1398e226.png";